<template>
  <tr>
    <td>
      <v-text-field
        dense
        hide-details
        class="pa-0 ma-0"
        ref="focusKS"
        disabled
        v-model="formData.ks"
      ></v-text-field>
    </td>
    <td>
      <v-combobox
        v-model="formData.kodettb"
        label="TTB"
        :items="items.ttb"
        :loading="loading.ttb"
        :disabled="loading.ttb"
        dense
        hide-details
        ref="focusTTB"
        @keydown.enter="focusKoliIn"
        @change="updateData, focusKoliIn"
      >
      </v-combobox>
    </td>
    <td>
      <v-text-field
        v-model="formData.koli_in"
        dense
        hide-details
        class="pa-0 ma-0"
        ref="focusKoliIn"
        @blur="updateData"
      ></v-text-field>
    </td>
    <td>
      <button type="button" @click="deleteTTB">
        <v-icon>mdi-delete</v-icon>
      </button>
    </td>
  </tr>
</template>

<script>
import axios from "axios";

export default {
  name: "FormContainerDetil",
  props: ["data"],
  data() {
    return {
      formData: {
        ks: this.data.ks,
        kodettb: {
          text: `${this.data.ttb.kodettb} - ${this.data.ttb.nottb} dari: ${
            this.data.ttb.pengirim_detil
              ? this.data.ttb.pengirim_detil.nama
              : ""
          }; utk: ${
            this.data.ttb.penerima_detil
              ? this.data.ttb.penerima_detil.nama
              : ""
          }; TKoli: ${this.data.ttb.total_koli}; sisa: ${this.data.ttb.sisa}`,
          value: this.data.ttb.kodettb
        },
        koli_in: this.data.koli_in
      },
      loading: {
        ttb: false
      },
      items: {
        ttb: []
      }
    };
  },
  methods: {
    async updateData() {
      await axios
        .put(`container-detil/${this.data.id}`, this.formData)
        .then(res => {
          this.fetchTTB();
          this.$emit("fetch-ttb");
        })
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    async fetchTTB() {
      this.loading.ttb = true;

      await axios
        .get(`ttb`)
        .then(res => {
          this.items.ttb = res.data.map(item => ({
            text: `${item.kodettb} - ${item.nottb} dari: ${
              item.pengirim_detil ? item.pengirim_detil.nama : ""
            }; utk: ${
              item.penerima_detil ? item.penerima_detil.nama : ""
            }; TKoli: ${item.total_koli}; sisa: ${item.sisa}`,
            value: item.kodettb
          }));

          this.loading.ttb = false;
        })
        .catch(err => {
          this.loading.ttb = false;

          alert(err.response.data.message);
        });
    },
    async deleteTTB() {
      this.loading.ttb = true;

      await axios
        .delete(`container-detil/${this.data.id}`)
        .then(res => {
          this.fetchTTB();
          this.$emit("fetch-ttb");
          this.$emit("update-detil");

          this.loading.ttb = false;
        })
        .catch(err => {
          this.loading.ttb = false;

          alert(err.response.data.message);
        });
    },
    focusKS() {
      this.$refs.focusKS.$refs.input.focus();
    },
    focusTTB() {
      this.$refs.focusTTB.$refs.input.click();
    },
    focusKoliIn() {
      this.$refs.focusKoliIn.$refs.input.focus();
    }
  },
  mounted() {
    this.fetchTTB();
  }
};
</script>
